const isLoading = (state = {}, action) => {
    if (action.type.match(/.+_REQUEST/)) {
        return { ...state, [action.type.replace("_REQUEST", "")]: true };
    }
    if (action.type.match(/.+_SUCCESS/)) {
        return { ...state, [action.type.replace("_SUCCESS", "")]: false };
    }
    if (action.type.match(/.+_FAIL/)) {
        return { ...state, [action.type.replace("_FAIL", "")]: false };
    }
    return state;
};

export default isLoading;
